import { render, staticRenderFns } from "./BayWindow.vue?vue&type=template&id=dda44dbe&scoped=true"
import script from "./BayWindow.vue?vue&type=script&lang=js"
export * from "./BayWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda44dbe",
  null
  
)

export default component.exports